import { AutomaticIntegration } from "../gateway/AutomaticIntegration/AutomaticIntegration";

export class GetEsocialAutomaticIntegrationUsecase {
    constructor() {
        this.AutomaticIntegrationGateway = new AutomaticIntegration();
    }

    async execute({ accountingId } = {}) {
        if (!accountingId) return null;

        const payload = this.sanitizeInput({ accountingId });
        const entity = await this.AutomaticIntegrationGateway.getBySystem(
            payload
        );

        if (!entity?.props?._id) return null;

        entity.setCertificateExpirationInfo();

        return entity;
    }

    sanitizeInput({ accountingId = "" } = {}) {
        return {
            accountingId: String(accountingId).trim(),
            system: "eSocial"
        };
    }
}
